export enum Timeframe {
  "1m" = "1m",
  "5m" = "5m",
  "15m" = "15m",
  "30m" = "30m",
  "1h" = "1h",
  "4h" = "4h",
  "6h" = "6h",
  "1d" = "1d",
  "1w" = "1w",
  "1M" = "1M",
}
